// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KGrF","colMin":"styles_colMin__hb_Pi"};